export enum QueryId {
  ViewsTimeseries = 'viewsTimeseries',
  ViewsBySegmentIdTable = 'viewsBySegmentIdTable',
  ViewsBySegmentIdTimeseries = 'viewsBySegmentIdTimeseries',
  ViewsByContentIdTable = 'viewsByContentIdTable',
  ViewsByUserTable = 'viewsByUserTable',
  ViewsByHostTable = 'viewsByHostTable',
  ViewsByPathnameTable = 'viewsByPathnameTable',

  UniqueViewsTimeseries = 'uniqueViewsTimeseries',
  UniqueViewsBySegmentIdTimeseries = 'uniqueViewsBySegmentIdTimeseries',
  UniqueViewsMetric = 'uniqueViewsMetric',
  UniqueViewsBySegmentIdTable = 'uniqueViewsBySegmentIdTable',

  InteractionsTable = 'interactionsTable',
  InteractionsTimeseries = 'interactionsTimeseries',
  InteractionsByContentIdTable = 'interactionsByContentIdTable',
  InteractionsByUserTable = 'interactionsByUserTable',
  InteractionsByPathnameTable = 'interactionsByPathnameTable',
  InteractionsByHostTable = 'interactionsByHostTable',
  InteractionsBySegmentIdTable = 'interactionsBySegmentIdTable',
  InteractionsBySegmentIdTimeseries = 'interactionsBySegmentIdTimeseries',

  ConversionRateTimeseries = 'conversionRateTimeseries',
  ConversionRateMetric = 'conversionRateMetric',
  ConversionRateBySegmentIdTimeseries = 'conversionRateBySegmentIdTimeseries',
  ConversionRateBySegmentIdTable = 'conversionRateBySegmentIdTable',

  ChecklistsCompletedTimeseries = 'checklistsCompletedTimeseries',
  ChecklistsCompletedMetric = 'checklistsCompletedMetric',
  ChecklistsCompletedByContentIdTable = 'checklistsCompletedByContentIdTable',
  ChecklistsCompletedBySegmentIdTable = 'checklistsCompletedBySegmentIdTable',
  FormsSubmittedTimeseries = 'formsSubmittedTimeseries',
  FormsSubmittedByContentIdTable = 'formsSubmittedByContentIdTable',
  FormsSubmittedBySegmentIdTable = 'formsSubmittedBySegmentIdTable',

  HotspotNames = 'hotspotNames',
  HotspotBeaconViewsByNodeIdTimeseries = 'hotspotBeaconViewsByNodeIdTimeseries',
  HotspotBeaconViewsBySegmentIdTimeseries = 'hotspotBeaconViewsBySegmentIdTimeseries',
  HotspotDismissedByNodeIdTimeseries = 'hotspotDismissedByNodeIdTimeseries',
  HotspotDismissedBySegmentIdTimeseries = 'hotspotDismissedBySegmentIdTimeseries',
  HotspotHistogram = 'hotspotHistogram',
  HotspotTooltipViewsByNodeIdTimeseries = 'hotspotTooltipViewsByNodeIdTimeseries',
  HotspotTooltipViewsBySegmentIdTimeseries = 'hotspotTooltipViewsBySegmentIdTimeseries',

  HotspotBeaconViewsByUsersTable = 'hotspotBeaconViewsByUsersTable',
  HotspotTooltipViewsByUsersTable = 'hotspotTooltipViewsByUsersTable',
  HotspotDismissedByUsersTable = 'hotspotDismissedByUsersTable',

  TourHistogram = 'tourHistogram',
  TourCompletedByUsersTable = 'tourCompletedByUsersTable',
  TourCompletedTimeseries = 'tourCompletedTimeseries',
  TourStepNames = 'tourStepNames',
  TourStepViewsByNodeIdTimeseries = 'tourStepViewsByNodeIdTimeseries',
  TourStepDismissedByNodeIdTimeseries = 'tourStepDismissedByNodeIdTimeseries',
  TourStepDismissedByUsersTable = 'tourStepDismissedByUsersTable',
  TourStepTooltipViewsByUsersTable = 'tourStepTooltipViewsByUsersTable',
  TourStepViewsBySegmentIdTimeseries = 'tourStepViewsBySegmentIdTimeseries',
  TourStepDismissedBySegmentIdTimeseries = 'tourStepDismissedBySegmentIdTimeseries',
  TourCompletedBySegmentIdTimeseries = 'tourCompletedBySegmentIdTimeseries',

  // Components
  InteractiveComponentsSearchTable = 'interactiveComponentsSearchTable',
  NodeChildLabelsTable = 'nodeChildLabelsTable',
  FlowHistogram = 'flowHistogram',
  ChecklistHistogram = 'checklistHistogram',
}
